import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  FormByIdParams,
  FormResource,
  getFormById,
  PrevDoctor,
  submitForm,
} from "../util/misc";

import { Form, Row, } from "antd";
import CenterSpinner from "../components/CenterSpinner";
import GeneralInfo from "../components/GeneralInfo";
import FormSkeleton from "../components/FormSkeleton";
import {
  prepInitialValues,
  MobileDepressionFormFields,
  MobileFamilyFormFields,
  MobileStressFormFields
} from "../util/MobileGeneralFormUtil";
import FormBuilderFieldComp from "../components/form-builder/formBuilderFields";
import { formBuilderField } from "../util/formBuilder";

interface UrlParams {
  formName: FormResource;
}

const MobileGeneralFormPage: React.FC = () => {
  const { formId, patientId } = useParams<FormByIdParams>();
  const { formName } = useParams<UrlParams>();
  const [prevDoctor, setPrevDoctor] = useState<PrevDoctor>({
    name: "",
    role: "none",
  });
  const [initialValues, setInitialValues] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [form] = Form.useForm();
  const history = useHistory();

  const formData: {[key: string]: {
    fields: formBuilderField[],
    title: string,
  }} = {
    MobileDepressionForm: {
      fields: MobileDepressionFormFields,
      title: "Depresión"
    },
    MobileFamilyForm: {
      fields: MobileFamilyFormFields,
      title: "Familia"
    },
    MobileStressForm: {
      fields: MobileStressFormFields,
      title: "Estrés"
    }
  }
  
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const data = await getFormById(formId, formName);
      if (!data || !data.form) {
        setIsLoading(false);
        return;
      }
      const values = data.form;
      const prevDoctorValues = data.prev_doctor;
      setPrevDoctor(prevDoctorValues);
      const newValues = await prepInitialValues(values);
      setInitialValues(newValues);
      setIsLoading(false);
      form.resetFields(Object.keys(newValues));
    })();
  }, []);

  const onFinish = async (values: any) => {
    if (!values) return;
    if (isSubmitting) return
    else setIsSubmitting(true)
    values = {
      ...values,
    }
    await submitForm(
      { values: values, patientId: patientId, formId: formId },
      formName
    );
    setIsLoading(false);
    setIsSubmitting(false)
    history.push({ pathname: `/${formName}/${patientId}` })
  };

  return !isLoading ? (
    <FormSkeleton onSubmit={() => form.submit()}>
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        className="data-form"
        onFinish={onFinish}
        scrollToFirstError={true}
      >
        <GeneralInfo
          patientId={patientId}
          prevDoctor={prevDoctor}
          formTitle={`(Aplicación familiar) ${formData[formName].title}`}
        />
        <Row 
          justify="start"
          align="bottom" gutter={16}
          style={{ width: "83%", margin: "auto"}}
        >
          {formData[formName].fields.map((formField) => (
            <FormBuilderFieldComp formField={formField} form={form} />
          ))}
        </Row>
      </Form>
    </FormSkeleton>
  ) : (
    <CenterSpinner />
  )
}

export default MobileGeneralFormPage;